import script from "./ConfiguratorQuantitySelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorQuantitySelector.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguratorQuantitySelector.vue?vue&type=style&index=0&id=69345430&lang=css"

const __exports__ = script;

export default __exports__